import { useEffect, useState } from "react";
import { useFetcher, useSearchParams } from "react-router-dom";
import { SearchTitleResponse } from "../../../../common/api/decimal/methods/search.ts";
import useSearchFavoritesSync from "./useSearchFavoritesSync.ts";
import { ManageAssetWithLicense } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { getSearchQuery } from "../query.ts";
import { SearchStatus } from "../types.ts";

export default function useTitleLicenseResults() {
  const [urlParams] = useSearchParams();
  const query = getSearchQuery(urlParams);
  const fetcher = useFetcher<SearchTitleResponse[]>();
  const [items, setItems] = useState<ManageAssetWithLicense[]>();

  useSearchFavoritesSync<ManageAssetWithLicense>(items, (updatedItems) => {
    setItems(updatedItems);
  });

  useEffect(() => {
    if (query && fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(`/search/api/titles/license?q=${query}`);
    }
  }, [fetcher, query]);

  useEffect(() => {
    if (fetcher.data && !items) {
      setItems(fetcher.data.map((hit) => hit.asset));
    }
  }, [fetcher.data, items]);

  const status: SearchStatus = items
    ? items.length
      ? "has-results"
      : "empty"
    : "loading";

  return {
    status,
    items: items ?? [],
  };
}
